import React from 'react';
import { QUERY_KEYS_SIA } from '../../../Common/hooks/useChartsData';
import GeneralResults from './GeneralResults';
import ServicesChartsDataProvider from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { subtitlesMap } from '../../Common/maps/subtitleMap';

const GeneralResultsWrapper = () => {
    return (
        <ServicesChartsDataProvider
            module={{
                title: 'Produção Ambulatorial - Resultados Gerais',
                className: 'services-container-dashboards',
                sectionTitle: 'do Total de Atendimentos'
            }}
            queryConfig={{
                key: QUERY_KEYS_SIA.GENERAL_RESULTS,
                url: 'governanceroom/dashboard/services/generalResults'
            }}
            subtitlesMap={subtitlesMap}
        >
            <GeneralResults />
        </ServicesChartsDataProvider>
    );
};

export default GeneralResultsWrapper;
